import axios from 'axios';
import serviceAuth from './serviceAuth'

/**
 * Сервис по работе с апи
 * в случае недействительного токена - выполнить logout
 * @property {function} createApi - создать объект axios
 * @property {function} get - сделать гет запрос
 * @property {function} post - сделать пост запрос
 */
class serviceApi {
    /**
     * Cоздать объект axios
     * @static
     * @returns {object}
     */
    static createApi() {
        let api = axios.create({
            baseURL: process.env.VUE_APP_BACKEND_HOST,
            headers: {
                'X-Auth-Token': serviceAuth.getAuthToken()
            }
        });
        return api;
    }
    /**
     * Сделать гет запрос
     * @static
     * @async
     * @param {string} route - маршрут
     * @param {object} params - парметры
     * @param {object} reqConfig - конфигурация запроса
     * @returns {Promise|Error}
     */
    static async get(route = "", params = {}, reqConfig = {}) {
        let api = this.createApi();
        try {
            let response = await api.get(route, params, reqConfig);
            return response;
        }
        catch(error) {
            throw new Error(error);
        }
    }

    /**
     * Сделать delete запрос
     * @static
     * @async
     * @param {string} route - маршрут
     * @param {object} params - парметры
     * @param {object} reqConfig - конфигурация запроса
     * @returns {Promise|Error}
     */
    static async delete(route = "", params = {}, reqConfig = {}) {
        let api = this.createApi();
        try {
            let response = await api.delete(route, params, reqConfig);
            return response;
        }
        catch(error) {
            throw new Error(error);
        }
    }
    /**
     * Сделать пост запрос
     * @static
     * @async
     * @param {string} route - маршрут
     * @param {object} postData - тело запроса
     * @param {object} reqConfig - конфигурация запроса
     * @returns {Promise|Error}
     */
    static async post(route = "", postData = {}, reqConfig = {}) {
        let api = this.createApi();
        try {
            let response = await api.post(route, postData, reqConfig);
            return response;
        }
        catch(error) {
            if (!error.response || error.response.status === 401) {
                let {status = null} = await serviceAuth.checkToken();
                if (status === 401) {
                    let {succes = false} = await serviceAuth.logout();
                    if (succes) {
                        window.vueRouter.push({name: 'check-phone'});
                    }
                }
                else {
                    throw new Error('not server');
                }
            }
            else {
                throw (error)
            }
        }
    }
}

export default serviceApi;